// @tenorlab/nuxt-dashboard-pro
// file: app/models/app/AppActionType.enum.ts
export const enum AppActionType {
  navigate,
  toggleMobileSidebarOpen,
  toggleSidebarCollapsed,
  toggleThemeEditorPopup,
}

export type TAppActionParams<T = unknown> = {
  type: AppActionType
  args?: T
}

export type TAppActionEmit<T = unknown> = {
  action: [params: TAppActionParams<T>]
}
